import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ForexImg from "../assets/Group 1618873619.svg";
import VisaImg from "../assets/visa main module.png";
import BgGif from "../assets/bg.gif";
import umbrellaImg from "../assets/Vector-44.png";
import searchPng from "../assets/Vector (3).png";
import style from "../components/section1.module.css";
import info from '../assets/Vector-9.png';

const Section1 = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = () => {
    if (searchValue.trim()) {
      navigate("/tours", { state: { searchTerm: searchValue } });
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className={style.main}>

      {/* Text Overlay */}
      <div className={style.textOverlay}>
        <h1>Awaken Your Wanderlust</h1>
        <h2>Book Your Next Journey</h2>
      </div>

      
      {/* Background Video Container */}
      <div className={style.bgContainer}>
        <img src={BgGif} alt="Background Video" className={style.bgImg} />
      </div>
      
      {/* Navigation & Search Container */}
      <div className={style.borderBox}>
        <nav className={style.navMain}>
          <ul className={style.heroSection}>
            <li className={style.Libtns}>
              <button className={style.purpleHover} onClick={() => handleNavigation("/tours")}> 
                <img src={umbrellaImg} alt="tour" width={30} height={30} />
                <span>Holiday</span>
              </button>
            </li>

            <li>
              <button className={style.purpleHover} onClick={() => handleNavigation("/visa")}>
                <img src={VisaImg} alt="visa" width={30} height={30} />
                <span>Visa</span>
              </button>
            </li>

            <li>
              <button className={style.purpleHover}>
                <img src={ForexImg} alt="forex" width={30} height={30} />
                <span>Forex</span>
              </button>
            </li>

            <div className="help-text">
              <span className="help-icon">
                <img src={info} alt="help" />
              </span>
              <span>Need some help?</span>
            </div>
            
          </ul>
          
          {/* Search Box Inside Navigation Container */}
          <div className={style.searchBox}>
            <div className={style.box1}>
              <img style={{width:'20px'}}src={searchPng} alt="searchIcon" className={style.searchIcon} />
              <input
                type="search"
                className={style.inputField}
                placeholder="Type Your Desired Location"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <button className={style.searchButton} onClick={handleSearch}>Search</button>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Section1;
